module.exports = __webpack_public_path__ + "img/pic3.a2d3da94.png";